import { redirect, type RouteObject } from 'react-router';

import { PermissionResource } from '@entities/tenant/permission';

import { lazyComponent } from '../../../lazy-component';
import { requirePermission } from '../../../require-permission';

export const couponsRoutes: RouteObject = {
  loader: () => {},
  children: [
    {
      path: '/admin/coupons',
      lazy: lazyComponent(() => import('@pages/tenant/coupons'), 'CouponsPage'),
      children: [
        { index: true, loader: () => redirect('/admin/coupons/list') },
        {
          path: 'list',
          loader: requirePermission(PermissionResource.TenantCoupons),
          lazy: lazyComponent(() => import('@pages/tenant/coupons'), 'CouponsListPage'),
        },
        {
          path: 'refund',
          loader: requirePermission(PermissionResource.TenantCouponRefundRequests),
          lazy: lazyComponent(() => import('@pages/tenant/coupons'), 'CouponsRefundPage'),
        },
      ],
    },
  ],
};
